/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_informations': {
    width: 16,
    height: 16,
    viewBox: '0 0 51.39 56.69',
    data: '<g _fill="#fff"><path pid="0" d="M28.35 56.69a28.35 28.35 0 1122.28-45.87l-2.81 2.22a24.77 24.77 0 10.66 29.73l2.91 2.09a28.43 28.43 0 01-23 11.83"/><path pid="1" d="M25.06 13.23h6.42v6.42h-6.42zM25.06 22.53h6.42v21.58h-6.42z"/></g>'
  }
})
